<template>
    <div>
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
      <div class="row">
        <div class="col-md-12">
            <div class="top-list-toolbar">
              <div>
                <h4 class="text-primary">Retur</h4>
                <ol class="breadcrumb breadcrumb-card-header">
                    <li class="breadcrumb-item">
                        <a href="javascript:void(0);" @click="backParent">Retur</a>
                    </li>
                    <li class="breadcrumb-item active">
                      <span>{{ retur.return_no }}</span>
                    </li>
                </ol>
                <button class="btn btn-success btn-sm pull-left dropdown-toggle" type="button" id="printsales" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-show="retur.return_no !== null">Action</button>
                <div class="dropdown-menu" aria-labelledby="printsales">
                  <a class="dropdown-item" href="javascript:void(0)" @click="setJournalReturn('reply',[])">Set Journal</a>
                  <a class="dropdown-item" href="javascript:void(0)" @click="printRetur">Print</a>
                  <a class="dropdown-item" href="javascript:void(0)" @click="createScrap">Scrap</a>
                  <a class="dropdown-item" href="javascript:void(0)" @click="setCOGSAll('reply')">Set COGS</a>
                  <a href="javascript:void(0)" class="dropdown-item" data-toggle="modal" data-target="#modalRequestEdit" data-backdrop="static" data-keyboard="false">Request Edit</a>
                  <a href="javascript:void(0)" class="dropdown-item" data-toggle="modal" data-target="#modalRequestVoid" data-backdrop="static" data-keyboard="false">Request Void</a>
                  <a href="javascript:void(0)" class="dropdown-item" @click="calcAll">Request Total</a>
                  <a href="javascript:void(0)" class="dropdown-item" @click="removeRetur()" v-if="authUser.permissions.return_unlock">Delete</a>
                  <a href="javascript:void(0)" class="dropdown-item" @click="unlockRetur()" v-if="authUser.permissions.return_unlock">Unlock</a>
                </div>
                <button type="button" @click="backParent" class="btn btn-sm btn-hard-outline-primary pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
                <button v-if="retur.id === null" type="button" @click="createRetur" class="btn btn-sm btn-soft-primary pull-left"><i class="fa fa-mail-forward" aria-hidden="true"></i> Save</button>
                <button v-if="retur.id === null" type="button" @click="createReturP" class="btn btn-sm btn-soft-primary pull-left"><i class="fa fa-mail-forward" aria-hidden="true"></i> To Purchasing</button>
                <button v-else type="button" @click="updateRetur" class="btn btn-sm btn-soft-primary pull-left"><i class="fa fa-mail-forward" aria-hidden="true"></i> Update</button>
                <button type="button" @click="validate" class="btn btn-sm btn-soft-primary pull-left"> Validate</button>
              </div>
            </div>
        </div>
      </div>
      <div class="card card-list">
        <div class="card-header">
          <strong class="font-24">Retur - {{ retur.return_no }}</strong>
        </div>
        <div class="card-body">
          <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="alert.length > 0">
            <ul v-for="(a, index) in alert" :key="index">
              <li v-html="a"></li>
            </ul>
          </div>
          <div class="row">
            <div class="col-md-4">
              <dl class="row dl-custom font-12">
                <dt class="col-md-4">Date</dt>
                <dd class="col-md-8">
                  <span v-if="retur.id !== null">{{ retur.return_date | dateFormat('DD/MM/YYYY') }}</span>
                  <span v-else>
                    <datetime v-model="retur.return_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local" v-if="authUser.permissions.sale_backdate"></datetime>
                    <datetime v-model="retur.return_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local" @input="checkDate" v-else></datetime>
                  </span>
                </dd>

                <dt class="col-md-4">Company</dt>
                <dd class="col-md-8">
                  <select v-model="retur.company_no" class="form-control form-control-lite"  :disabled="retur.id !== null">
                    <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                  </select>
                </dd>
              </dl>
              <dl class="row dl-custom font-12">
                <dt class="col-md-4">Type</dt>
                <dd class="col-md-8">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="typePurchasing" value="purchasing" v-model="retur.type" :disabled="retur.id !== null" @change="setType">
                    <label class="form-check-label" for="typePurchasing">Purchasing</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="typeSales" value="sales" v-model="retur.type" :disabled="retur.id !== null" @change="setType">
                    <label class="form-check-label" for="typeSales">Sales</label>
                  </div>
                </dd>
              </dl>
              <dl class="row dl-custom font-12">
                <dt class="col-md-4">Category</dt>
                <dd class="col-md-8">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="cancel" v-model="retur.category" @change="setTax" :disabled="retur.lock">
                    <label class="form-check-label" for="inlineRadio1">Batal Salesman</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="others" v-model="retur.category" @change="setTax" :disabled="retur.lock">
                    <label class="form-check-label" for="inlineRadio2">Lain - lain</label>
                  </div>
                </dd>
              </dl>
              <dl class="row dl-custom font-12">
                <dt class="col-md-4">Notes</dt>
                <dd class="col-md-8">
                  <textarea rows="5" v-model="retur.notes" class="form-control form-control-list" :disabled="retur.lock"></textarea>
                </dd>
              </dl>
              <dl class="row dl-custom font-12">
                <dt class="col-md-4">Tax</dt>
                <dd class="col-md-8">
                  <select v-model="retur.tax_id" class="form-control form-control-lite" @change="setTax" :disabled="retur.lock">
                    <option v-for="t in taxList" :key="t.id" :value="t.id">Tax: {{ t.name }}</option>
                  </select>
                </dd>
              </dl>
            </div>
            <div class="col-md-4">
                <div class="float-left">
                <address class="font-13">
                  <div v-show="retur.type === 'sales'">
                    <strong class="font-24 mr-2" v-show="retur.type === 'sales'">Customer</strong>
                    <button type="button" v-show="retur.type === 'sales'" data-toggle="modal" data-target="#modalCustomerList" data-backdrop="static" data-keyboard="false" class="btn btn-sm btn-hard-primary" @click="getCustomerList"  :disabled="retur.lock">
                      <i class="fa fa-search"></i>
                    </button>
                    <hr>
                    <br>
                    <dl class="dl_customer row mt-3">
                      <dt class="col-md-4">Customer No.</dt>
                      <dd class="col-md-8">{{ retur.customer_no }}</dd>

                      <dt class="col-md-4">Name:</dt>
                      <dd class="col-md-8">{{ retur.customer.name }}</dd>

                      <dt class="col-md-4">Address:</dt>
                      <dd class="col-md-8">{{ retur.customer.address }}</dd>
                    </dl>
                  </div>
                  <div v-show="retur.type === 'purchasing'">
                    <strong class="font-24 mr-3">Vendor</strong>
                    <button type="button" data-toggle="modal" data-target="#modalVendorList" data-backdrop="static" data-keyboard="false" class="btn btn-sm btn-hard-primary" @click="getVendorList"  :disabled="retur.lock"><i class="fa fa-search"></i></button>
                    <hr>
                    <br>
                    <b  class="font-16 mr-3">{{ retur.vendor_no }}</b>
                    <dl class="dl_customer row mt-3">
                      <dt class="col-md-4">Name:</dt>
                      <dd class="col-md-8">{{ retur.vendor.name }}</dd>

                      <dt class="col-md-4">Address:</dt>
                      <dd class="col-md-8">{{ retur.vendor.address }}</dd>
                    </dl>
                  </div>
                </address>
                </div>
            </div>
            <div class="col-md-4" v-show="retur.type === 'sales'">
                <div class="float-left">
                <address class="font-13">
                  <strong class="font-24 mr-3">Sales</strong>
                  <button type="button" data-toggle="modal" data-target="#modalSale" data-backdrop="static" data-keyboard="false" class="btn btn-sm btn-hard-primary" @click="getSales" :disabled="retur.lock">
                    <i class="fa fa-search"></i>
                  </button>
                  <hr>
                  <br/>
                  <span class="font-16 mt-3">
                    <b>{{ retur.sale_no }}</b>
                    <button v-if="retur.sale_no !== null" type="button" class="btn btn-sm btn-outline-danger ml-3" @click="removeSale" :disabled="retur.lock"><i class="fa fa-trash"></i></button>
                  </span>
                  <br>
                  <br>
                  <dl class="dl-custom row">
                    <dt class="col-md-4">Date</dt>
                    <dd class="col-md-8">{{ retur.sale.sale_date | dateFormat('DD/MM/YYYY') }}</dd>
                    <dt class="col-md-4">Total</dt>
                    <dd class="col-md-8">{{ retur.sale.total | currency }}</dd>
                    <dt class="col-md-4">Salesman</dt>
                    <dd class="col-md-8">
                      <v-select :options="getUserSalesman" :reduce="salesman => salesman.meta.code" label="salesman" v-model="retur.salesman_id" class="vsc-custom" :disabled="retur.lock"/>
                    </dd>
                  </dl>
                </address>
                </div>
            </div>
            <div class="col-md-4" v-show="retur.type === 'purchasing'">
                <div class="float-left">
                <address class="font-13">
                    <strong class="font-24 mr-3">Purchasing</strong>
                    <button type="button" data-toggle="modal" data-target="#modalPurchase" data-backdrop="static" data-keyboard="false" class="btn btn-sm btn-hard-primary" @click="getPurchasing" :disabled="retur.lock">
                      <i class="fa fa-search"></i>
                    </button>
                    <hr>
                    <br>
                    <span class="font-16 mt-3">
                    <b>{{ retur.purchasing_no }}</b>
                    <button v-if="retur.purchasing_no !== null" type="button" class="btn btn-sm btn-outline-danger ml-3" @click="removePurchasing" :disabled="retur.lock"><i class="fa fa-trash"></i></button>
                    </span>
                    <dl class="dl-custom row">
                      <dt class="col-md-4">Date</dt>
                      <dd class="col-md-8">{{ retur.purchasing.purchasing_date}}</dd>
                      <dt class="col-md-4">Total</dt>
                      <dd class="col-md-8">{{ retur.purchasing.total | currency }}</dd>
                    </dl>
                </address>
                </div>
            </div>
          </div>
          <hr class="mt-5 mb-5">
          <ul class="nav nav-tabs nav-bordered">
            <li class="nav-item"><a href="#return" data-toggle="tab" aria-expanded="false" class="nav-link active">Return</a></li>
            <li class="nav-item"><a href="#journal" data-toggle="tab" aria-expanded="false" class="nav-link">Journal</a></li>
          </ul>
          <div class="tab-content">
            <div class="tab-pane active" id="return">
              <!-- Sales & Sale No -->
              <div class="row" v-if="retur.type === 'sales' && retur.sale_no !== null">
                <div class="col-md-5">
                  <strong class="font-24">Product Sales:</strong>
                  <div class="table-responsive">
                      <table class="table table-item table-sm table-striped">
                          <thead>
                              <th>Product</th>
                              <th>Qty</th>
                              <th>Price</th>
                              <th>Discount</th>
                              <th>DPP</th>
                              <th>Tax</th>
                              <th class="text-right">Total</th>
                              <th>Order No</th>
                              <th>#</th>
                          </thead>
                          <tbody>
                          <tr v-for="(d, index) in retur.sale.details" :key="index">
                              <td><b>[{{ d.product_no }}]</b> {{ d.description }}</td>
                              <td>{{ d.qty }}</td>
                              <td class="text-right">{{ d.price | currency }}</td>
                              <td class="text-right">{{ d.discount | currency }}</td>
                              <td class="text-right">{{ d.subtotal | currency }}</td>
                              <td class="text-right">{{ d.tax | currency }}</td>
                              <td class="text-right">{{ d.total | currency }}</td>
                              <td class="text-right">{{ d.order_no }}</td>
                              <td><button type="button" class="btn btn-sm btn-outline-primary" @click="addToReturn(index)" :disabled="retur.lock"><i class="fa fa-share"></i></button></td>
                          </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td><b>Subtotal:</b></td>
                              <td class="text-right">{{ retur.sale.subtotal | currency }}</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td><b>Discount:</b></td>
                              <td class="text-right">{{ retur.sale.discount | currency }}</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td><b>Tax:</b></td>
                              <td class="text-right">{{ retur.sale.tax | currency }}</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td><b>Total:</b></td>
                              <td class="text-right">{{ retur.sale.total | currency }}</td>
                              <td></td>
                            </tr>
                          </tfoot>
                      </table>
                  </div>
                </div>
                <div class="col-md-7">
                  <strong class="font-24">Retur Product:</strong>
                  <div class="table-responsive">
                    <table class="table table-item table-sm table-striped">
                        <thead>
                            <th style="width: 30%">Product</th>
                            <th style="width: 10%">Qty</th>
                            <th style="width: 10%">Uom</th>
                            <th style="width: 10%">Amount</th>
                            <th class="text-right">Discount</th>
                            <th class="text-right">%</th>
                            <th class="text-right">DPP</th>
                            <th class="text-right">Tax</th>
                            <th class="text-right">Total</th>
                            <th class="text-right">Denda</th>
                            <th>#</th>
                        </thead>
                        <tbody>
                          <tr v-for="(r, index) in retur.details" :key="index">
                              <td>
                                <v-select :options="productselect" :reduce="product => product.meta.code" label="product" v-model="r.product_no" @input="setProductRetur(index)" :disabled="retur.lock"/>
                              </td>
                              <td>
                                <input type="text" class="form-control" v-model="r.qty" @keyup="calcrow(index)" :disabled="retur.lock"/>
                              </td>
                              <td>{{ r.uom_id }}</td>
                              <td><input type="text" class="form-control form-right" v-money="money" v-model="r.amount" @keyup="calcrow(index)" :disabled="retur.lock"/></td>
                              <td>{{ r.discount | currency }}</td>
                              <td><input type="text" class="form-control form-right" v-model="r.discount_percentage" @keyup="calcrow(index)" :disabled="retur.lock"/></td>
                              <td class="text-right">{{ r.subtotal | currency }}</td>
                              <td class="text-right">{{ r.tax | currency }} ({{ r.taxes }})</td>
                              <td class="text-right">{{ r.total | currency }}</td>
                              <td class="text-right">{{ r.penalty_amount | currency }}</td>
                              <td>
                                  <button type="button" class="btn btn-sm btn-outline-danger" @click="removeReturn(index)" :disabled="retur.lock"><i class="fa fa-trash"></i></button>
                                  <button type="button" class="btn btn-sm btn-outline-info" @click="setIndexDetail(index)" data-toggle="modal" data-target="#modalReturNote" data-backdrop="static" data-keyboard="false"><i class="fa fa-file" aria-hidden="true"></i></button>
                                  <button type="button" class="btn btn-sm btn-outline-success" @click="setProductRetur(index)" :disabled="retur.lock"><i class="fa fa-refresh" aria-hidden="true"></i> Process</button>
                              </td>
                          </tr>
                          <tr>
                            <td colspan="12">
                              <span class="link-secondary" @click="addNewLine"  v-if="retur.lock === false">+ Add Product</span>
                            </td>
                          </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                              <td colspan="8" class="text-right"><b>Subtotal</b></td>
                              <td class="text-right">{{ totalSubtotalDetailReturn | currency }}</td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr>
                              <td colspan="8" class="text-right"><b>Discount</b></td>
                              <td class="text-right">{{ totalDiscountDetailReturn | currency }}</td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr>
                              <td colspan="8" class="text-right"><b>Tax</b></td>
                              <td class="text-right">{{ totalTaxDetailReturn | currency }}</td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr>
                              <td colspan="8" class="text-right"><b>Total</b></td>
                              <td class="text-right">{{ retur.total | currency }}</td>
                              <td></td>
                              <td></td>
                            </tr>
                        </tfoot>
                    </table>
                  </div>
                </div>
              </div>
              <!-- Purchasing & Purchasing No -->
              <div class="row" v-else-if="retur.type === 'purchasing' && retur.purchasing_no !== null">
                <div class="col-md-5">
                  <strong class="font-24">Product Purchasing:</strong>
                  <div class="table-responsive">
                      <table class="table table-item table-sm table-striped">
                          <thead>
                              <th>Product</th>
                              <th>Qty</th>
                              <th class="text-right">Price</th>
                              <th class="text-right">Discount</th>
                              <th class="text-right">DPP</th>
                              <th class="text-right">Tax</th>
                              <th class="text-right">Total</th>
                              <th>#</th>
                          </thead>
                          <tbody>
                          <tr v-for="(d, index) in retur.purchasing.details" :key="index">
                              <td><b>[{{ d.product_no }}]</b> {{ d.description }}</td>
                              <td>{{ d.qty }}</td>
                              <td>{{ d.price | currency }}</td>
                              <td class="text-right">{{ d.discount | currency }}</td>
                              <td class="text-right">{{ d.subtotal | currency }}</td>
                              <td class="text-right">{{ d.tax | currency }}</td>
                              <td class="text-right">{{ d.total | currency }}</td>
                              <td>
                                  <button type="button" class="btn btn-sm btn-outline-success" @click="addToReturnPurchasing(index)" :disabled="retur.lock"><i class="fa fa-share"></i></button>
                              </td>
                          </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td><b>Subtotal:</b></td>
                              <td class="text-right">{{ retur.purchasing.subtotal | currency }}</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td><b>Discount:</b></td>
                              <td class="text-right">{{ retur.purchasing.discount | currency }}</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td><b>Tax:</b></td>
                              <td class="text-right">{{ retur.purchasing.tax | currency }}</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td><b>Total:</b></td>
                              <td class="text-right">{{ retur.purchasing.total | currency }}</td>
                              <td></td>
                            </tr>
                          </tfoot>
                      </table>
                  </div>
                </div>
                <div class="col-md-7">
                  <strong class="font-24">Retur Product:</strong>
                  <div class="table-responsive">
                    <table class="table table-item table-sm table-striped">
                        <thead>
                            <th style="width: 30%">Product</th>
                            <th>Qty</th>
                            <th>Uom</th>
                            <th>Notes</th>
                            <th>Amount</th>
                            <th class="text-right">Discount</th>
                            <th class="text-right">DPP</th>
                            <th class="text-right">Tax</th>
                            <th class="text-right">Total</th>
                            <th class="text-right">Denda</th>
                            <th>#</th>
                        </thead>
                        <tbody>
                            <tr v-for="(r, index) in retur.details" :key="index">
                                <td>
                                  <v-select :options="productselect" :reduce="product => product.meta.code" label="product" v-model="r.product_no" @input="setProductRetur(index)" :disabled="retur.lock"/>
                                </td>
                                <td>
                                  <input type="text" class="form-control" v-model="r.qty" @keyup="calcrow(index)" :disabled="retur.lock"/>
                                </td>
                                <td>{{ r.uom_id }}</td>
                                <td>
                                  <textarea class="form-control" v-model="r.notes" :disabled="retur.lock"></textarea>
                                </td>
                                <td class="text-right">{{ r.amount | currency }}</td>
                                <td class="text-right">{{ r.discount | currency }}</td>
                                <td class="text-right">{{ r.subtotal | currency }}</td>
                                <td class="text-right">{{ r.tax | currency }}</td>
                                <td class="text-right">{{ r.total | currency }}</td>
                                <td class="text-right">{{ r.penalty_amount | currency }}</td>
                                <td>
                                  <button type="button" class="btn btn-sm btn-outline-danger" @click="removeReturn(index)" :disabled="retur.lock"><i class="fa fa-trash"></i></button>
                                  <button type="button" class="btn btn-sm btn-outline-info" @click="setIndexDetail(index)" data-toggle="modal" data-target="#modalReturNote" data-backdrop="static" data-keyboard="false"><i class="fa fa-file" aria-hidden="true"></i></button>
                                </td>
                            </tr>
                            <tr>
                              <td colspan="12">
                                <span class="link-secondary" @click="addNewLine"  v-if="retur.lock === false">+ Add Product</span>
                              </td>
                            </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td colspan="8" class="text-right"><b>Subtotal</b></td>
                            <td class="text-right">{{ totalSubtotalDetailReturn | currency }}</td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr>
                            <td colspan="8" class="text-right"><b>Discount</b></td>
                            <td class="text-right">{{ totalDiscountDetailReturn | currency }}</td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr>
                            <td colspan="8" class="text-right"><b>Tax</b></td>
                            <td class="text-right">{{ totalTaxDetailReturn | currency }}</td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr>
                            <td colspan="8" class="text-right"><b>Total</b></td>
                            <td class="text-right">{{ totalDetailReturn | currency }}</td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr>
                            <td colspan="8" class="text-right"><b><i>Total Denda</i></b></td>
                            <td class="text-right">{{ totalDetailPenalty | currency }}</td>
                            <td></td>
                            <td></td>
                          </tr>
                        </tfoot>
                    </table>
                  </div>
                </div>
              </div>
              <!-- Sale & sale no null -->
              <div class="row" v-else-if="retur.type === 'sales' && retur.sale_no === null">
                <div class="col-md-12">
                  <strong class="font-24">Retur Sale Product:</strong>
                  <div class="table-responsive">
                    <table class="table table-item table-sm table-striped">
                        <thead>
                            <th style="width: 20%">Product</th>
                            <th style="width: 10%">Qty</th>
                            <th style="width: 10%">Uom</th>
                            <th style="width: 10%" class="text-right">Amount</th>
                            <th>Discount</th>
                            <th class="text-right">%</th>
                            <th class="text-right">DPP</th>
                            <th class="text-right">Tax</th>
                            <th class="text-right">Total</th>
                            <th class="text-right">Denda</th>
                            <th class="text-right">HPP</th>
                            <th style="width: 10%">#</th>
                        </thead>
                        <tbody>
                            <tr v-for="(r, index) in retur.details" :key="index">
                                <td>
                                  <v-select :options="productselect" :reduce="product => product.meta.code" label="product" v-model="r.product_no" @input="setProductRetur(index)" :disabled="retur.lock"/>
                                </td>
                                <td>
                                  <input type="text" class="form-control" v-model="r.qty" @keyup="calcrow(index)" :disabled="retur.lock"/>
                                </td>
                                <td>
                                  <select v-model="r.uom_id" class="form-control" :disabled="retur.lock">
                                    <option v-for="u in r.uomList" :key="u.id" :value="u.id">{{ u.name }}</option>
                                  </select>
                                </td>
                                <td><input type="text" class="form-control form-right" v-money="money" v-model="r.amount" disabled="disabled"/></td>
                                <td>{{ r.discount | currency }}</td>
                                <td><input type="text" class="form-control form-right" v-model="r.discount_percentage" @keyup="calcrow(index)" :disabled="retur.lock"/></td>
                                <td class="text-right">{{ r.subtotal | currency }}</td>
                                <td class="text-right">{{ r.tax | currency }}</td>
                                <td class="text-right">{{ r.total | currency }}</td>
                                <td class="text-right">{{ r.penalty_amount | currency }}</td>
                                <td class="text-right">{{ r.cost | currency }}</td>
                                <td>
                                  <button type="button" class="btn btn-sm btn-outline-danger" @click="removeReturn(index)" :disabled="retur.lock"><i class="fa fa-trash"></i></button>
                                  <button type="button" class="btn btn-sm btn-outline-success" @click="setProductRetur(index)" :disabled="retur.lock">
                                    <i class="fa fa-refresh" aria-hidden="true"></i>
                                  </button>
                                  <button type="button" class="btn btn-sm btn-outline-info" @click="setIndexDetail(index)" data-toggle="modal" data-target="#modalReturNote" data-backdrop="static" data-keyboard="false"><i class="fa fa-file" aria-hidden="true"></i></button>
                                </td>
                            </tr>
                            <tr>
                              <td colspan="12">
                                <span class="link-secondary" @click="addNewLine"  v-if="retur.lock === false">+ Add Product</span>
                              </td>
                            </tr>
                            <tr>
                              <td colspan="10" class="text-right"><b>Subtotal</b></td>
                              <td class="text-right">{{ totalSubtotalDetailReturn | currency }}</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td colspan="10" class="text-right"><b>Discount</b></td>
                              <td class="text-right">({{ totalDiscountDetailReturn | currency }})</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td colspan="10" class="text-right"><b>Tax</b></td>
                              <td class="text-right">{{ totalTaxDetailReturn | currency }}</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td colspan="10" class="text-right"><b>Total</b></td>
                              <td class="text-right">{{ totalDetailReturn | currency }}</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td colspan="10" class="text-right"><b><i>Total Denda</i></b></td>
                              <td class="text-right">{{ totalDetailPenalty | currency }}</td>
                              <td></td>
                            </tr>
                        </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!-- Purchasing & purchasing no null -->
              <div class="row" v-else-if="retur.type === 'purchasing' && retur.purchasing_no === null">
                <div class="col-md-12">
                  <strong class="font-24">Retur Purchasing Product:</strong>
                  <div class="table-responsive">
                    <table class="table table-item table-sm table-striped">
                        <thead>
                            <th style="width: 30%">Product</th>
                            <th>Qty</th>
                            <th style="width: 10%">Uom</th>
                            <th>Notes</th>
                            <th class="text-right">Amount</th>
                            <th>Discount</th>
                            <th class="text-right">%</th>
                            <th class="text-right">DPP</th>
                            <th class="text-right">Tax</th>
                            <th class="text-right">Total</th>
                            <th class="text-right">Denda</th>
                            <th class="text-right">Cost</th>
                            <th style="width: 10%">#</th>
                        </thead>
                        <tbody>
                            <tr v-for="(r, index) in retur.details" :key="index">
                                <td>
                                  <v-select :options="productselect" :reduce="product => product.meta.code" label="product" v-model="r.product_no" @input="setProductRetur(index)" :disabled="retur.lock"/>
                                </td>
                                <td>
                                  <input type="text" class="form-control" v-model="r.qty" @keyup="calcrow(index)" :disabled="retur.lock"/>
                                </td>
                                <td>
                                  <select v-model="r.uom_id" class="form-control" :disabled="retur.lock">
                                    <option v-for="u in r.uomList" :key="u.id" :value="u.id">{{ u.name }}</option>
                                  </select>
                                </td>
                                <td>
                                  <textarea class="form-control" v-model="r.notes" :disabled="retur.lock"></textarea>
                                </td>
                                <td><input type="type" class="form-control form-right" v-money="money" v-model="r.amount" :disabled="retur.lock"/></td>
                                <td>{{ r.discount | currency }}</td>
                                <td><input type="type" class="form-control form-right" v-model="r.discount_percentage" @keyup="calcrow(index)" :disabled="retur.lock"/></td>
                                <td class="text-right">{{ r.subtotal | currency }}</td>
                                <td class="text-right">{{ r.tax | currency }}</td>
                                <td class="text-right">{{ r.total | currency }}</td>
                                <td class="text-right">{{ r.penalty_amount | currency }}</td>
                                <td class="text-right">
                                  <input type="type" class="form-control form-right" v-money="money2" v-model="r.cost" :disabled="retur.lock"/>
                                </td>
                                <td>
                                  <button type="button" class="btn btn-sm btn-outline-danger" @click="removeReturn(index)" :disabled="retur.lock"><i class="fa fa-trash"></i></button>
                                  <button type="button" class="btn btn-sm btn-outline-success" @click="setProductRetur(index)" :disabled="retur.lock">
                                    <i class="fa fa-refresh" aria-hidden="true"></i>
                                  </button>
                                  <button type="button" class="btn btn-sm btn-outline-info" @click="setIndexDetail(index)" data-toggle="modal" data-target="#modalReturNote" data-backdrop="static" data-keyboard="false"><i class="fa fa-file" aria-hidden="true"></i></button>
                                </td>
                            </tr>
                            <tr>
                              <td colspan="13">
                                <span class="link-secondary" @click="addNewLine"  v-if="retur.lock === false">+ Add Product</span>
                              </td>
                            </tr>
                            <tr>
                              <td colspan="9" class="text-right"><b>Subtotal</b></td>
                              <td class="text-right">{{ totalSubtotalDetailReturn | currency }}</td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr>
                              <td colspan="9" class="text-right"><b>Discount</b></td>
                              <td class="text-right">({{ totalDiscountDetailReturn | currency }})</td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr>
                              <td colspan="9" class="text-right"><b>Tax</b></td>
                              <td class="text-right">{{ totalTaxDetailReturn | currency }}</td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr>
                              <td colspan="9" class="text-right"><b>Total</b></td>
                              <td class="text-right">{{ totalDetailReturn | currency }}</td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr>
                              <td colspan="9" class="text-right"><b><i>Total Denda</i></b></td>
                              <td class="text-right">{{ totalDetailPenalty | currency }}</td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>
                        </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane" id="journal">
              <div class="table-responsive">
                <table class="table table-sm table-item table-hover table-striped">
                  <thead>
                    <th>Journal Code</th>
                    <th>Date</th>
                    <th>Account Code</th>
                    <th>Remark</th>
                    <th class="text-right">Debit</th>
                    <th class="text-right">Credit</th>
                  </thead>
                  <tbody>
                    <tr v-for="j in retur.journals" :key="j.id">
                      <td>
                        <span v-if="j.level === 1">
                          <b>{{ j.journal_code }} - {{ j.journal_description }}</b>&nbsp;
                          <span class="badge badge-success" v-if="j.status === 'posted'">{{ j.status }}</span>
                          <span class="badge badge-warning" v-else-if="j.status === 'draft'">{{ j.status }}</span>
                        </span>
                        <span v-else></span>
                      </td>
                      <td>{{ j.journal_date | dateFormat('DD/MM/YYYY') }}</td>
                      <td><b>{{ j.account_code }} {{ j.account }}</b></td>
                      <td>{{ j.remark }}</td>
                      <td class="text-right">
                        <span v-if="j.level === 2">{{ j.debit | currency }}</span>
                        <span v-if="j.level === 3"><b>{{ j.debit | currency }}</b></span>
                        <span v-else></span>
                      </td>
                      <td class="text-right">
                        <span v-if="j.level === 2">{{ j.credit | currency }}</span>
                        <span v-if="j.level === 3"><b>{{ j.credit | currency }}</b></span>
                        <span v-else></span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CustomerFormModal @createCustomer="createCustomer" />
      <VendorFormModal @createVendor="createVendor" />
      <CustomerListModal @selectCustomerList="selectCustomerList" />
      <VendorListModal @selectVendorList="selectVendorList" />
      <SaleSelectModal @selectSales="selectSales" />
      <PurchasingSelectModal @selectPurchasing="selectPurchasing" />
      <SalesRequestModal @getRequestEdit="requestEdit" @getRequestVoid="requestVoid" />
      <PurchasingReturnNoteModal :detailReturn="detailReturn" :retur="retur"/>
      <div class="row justify-content-md-center">
        <div class="col-md-6">
          <h5>Logs:</h5>
          <div class="alert alert-info" role="alert" v-for="l in retur.logs" :key="l.id">
            <b>{{ l.user }}</b> - {{ l.log_date | dateFormat('DD/MM/YYYY HH:mm:ss') }} <span>"{{ l.description }}"</span>
          </div>
        </div>
      </div>
      <div class="row">
        <!-- <div class="col-md-4"><pre>{{ retur }}</pre></div> -->
        <!-- <div class="col-md-4"><pre>{{ dataCollect }}</pre></div> -->
        <!-- <div class="col-md-4"><pre>{{ productListSelect }}</pre></div> -->
      </div>
    </div>
</template>

<script>
import Axios from 'axios'
import { getHeader, productUrl, returnUrl, setQtyTotalUrl, sale2Url, lockUrl } from '../../config'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import CustomerFormModal from '@/components/customer/CustomerFormModal.vue'
import VendorFormModal from '@/components/vendor/VendorFormModal.vue'
import CustomerListModal from '@/components/customer/CustomerListModal.vue'
import VendorListModal from '@/components/vendor/VendorListModal.vue'
import PurchasingSelectModal from '@/components/purchasing/PurchasingSelectModal.vue'
import SaleSelectModal from '@/components/sales/SaleSelectModal.vue'
import SalesRequestModal from '@/components/sales/SalesRequestModal.vue'
import PurchasingReturnNoteModal from '@/components/purchasing/PurchasingReturnNoteModal.vue'

export default {
  name: 'SaleReturnForm',
  components: {
    Loading,
    CustomerFormModal,
    VendorFormModal,
    CustomerListModal,
    VendorListModal,
    PurchasingSelectModal,
    SaleSelectModal,
    SalesRequestModal,
    PurchasingReturnNoteModal
  },
  props: ['retur'],
  data () {
    return {
      alert: [],
      detailReturn: {
        notes: null
      },
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      },
      money2: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
      productListSelect: state => state.products.productListSelect,
      taxList: state => state.taxes.taxList,
      vendorList: state => state.vendors.vendorList,
      warehouseList: state => state.warehouses.warehouseList,
      employeeList: state => state.employees.employeeList,
      companyList: state => state.companies.companyList,
      authUser: state => state.users.authUser
    }),
    totalDetailPenalty () {
      var sum = 0
      var array = this.retur.details
      if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
          sum += parseFloat(array[i].penalty_amount)
        }
      }
      return sum
    },
    totalDiscountDetailReturn () {
      var sum = 0
      var array = this.retur.details
      if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
          sum += parseFloat(array[i].qty) * parseFloat(array[i].discount)
        }
      }
      return sum
    },
    totalSubtotalDetailReturn () {
      var sum = 0
      var array = this.retur.details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].amount.replace(/\./g, '')) * parseFloat(array[i].qty)
      }
      return sum
    },
    totalTaxDetailReturn () {
      // var sum = 0
      // var array = this.retur.details
      // for (let i = 0; i < array.length; i++) {
      //   sum += parseFloat(array[i].tax) * parseFloat(array[i].qty)
      // }
      // return sum
      var array = this.retur.details
      var sum = 0
      var tax = this.taxList.find(d => d.id === this.retur.tax_id)
      if (tax) {
        for (let i = 0; i < array.length; i++) {
          var taxAmount = 0
          if (tax.include === false) {
          } else {
            if (tax.amount === '11') {
              // Old
              taxAmount = parseFloat(array[i].subtotal) * 11 / 100
              sum += parseFloat(array[i].qty) * taxAmount
            } else {
              taxAmount = parseFloat(array[i].subtotal) * 10 / 100
              sum += parseFloat(array[i].qty) * taxAmount
            }
          }
        }
      }
      var totalTax = Math.round(sum)
      return totalTax
    },
    totalDetailReturn () {
      var sum = 0
      var array = this.retur.details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    getTotalDPP () {
      var array = this.retur.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        var dpp = array[i].subtotal
        sum += parseFloat(array[i].qty) * parseFloat(dpp)
      }
      return sum
    },
    productselect: function () {
      var loop = []
      var array = this.productListSelect
      for (var x = 0; x < array.length; x++) {
        var obj = {
          product: '[' + array[x].product_no + '] ' + array[x].product_name,
          meta: {
            code: array[x].product_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    vendorselect: function () {
      var loop = []
      var array = this.vendorList
      for (var x = 0; x < array.length; x++) {
        var obj = {
          vendor: '[' + array[x].vendor_no + '] ' + array[x].name,
          meta: {
            code: array[x].vendor_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    getUserSalesman: function () {
      var array = this.employeeList.filter(e => e.position_id === 'H4.1' || e.position_id === 'H4.2' || e.position_id === 'H1' || e.position_id === 'H2')
      var loop = []
      for (let a = 0; a < array.length; a++) {
        var obj = {
          salesman: '[' + array[a].employee_no + '] ' + array[a].name,
          meta: {
            code: array[a].employee_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    dataCollect () {
      var rtr = this.retur
      var detail = []
      var array = rtr.details.filter(d => d.product_no !== null)
      for (let i = 0; i < array.length; i++) {
        var cost = array[i].cost
        if (typeof array[i].id === 'undefined') {
          var obj = {
            return_no: null,
            product_no: array[i].product_no,
            product_sku: array[i].product_sku,
            serial_number: array[i].serial_number,
            uom_id: array[i].uom_id,
            qty: array[i].qty,
            amount: array[i].amount.replace(/\./g, ''),
            notes: array[i].notes,
            warehouse_no: array[i].warehouse_no,
            branch_no: array[i].branch_no,
            company_no: array[i].company_no,
            discount: array[i].discount,
            discount_percentage: array[i].discount_percentage,
            tax_id: array[i].tax_id,
            tax: array[i].tax,
            total: array[i].total,
            return_date: null,
            cost: cost,
            cost_id: array[i].cost_id,
            penalty_amount: array[i].penalty_amount,
            subtotal: array[i].subtotal,
            order_no: array[i].order_no,
            diff_product_parent: array[i].diff_product_parent
          }
          detail.push(obj)
        } else {
          var obj2 = {
            id: array[i].id,
            return_no: array[i].return_no,
            product_no: array[i].product_no,
            product_sku: array[i].product_sku,
            serial_number: array[i].serial_number,
            uom_id: array[i].uom_id,
            qty: array[i].qty,
            amount: array[i].amount.replace(/\./g, ''),
            notes: array[i].notes,
            warehouse_no: array[i].warehouse_no,
            branch_no: array[i].branch_no,
            company_no: array[i].company_no,
            discount: array[i].discount,
            discount_percentage: array[i].discount_percentage,
            tax_id: array[i].tax_id,
            tax: array[i].tax,
            total: array[i].total,
            return_date: null,
            cost: cost,
            cost_id: array[i].cost_id,
            penalty_amount: array[i].penalty_amount,
            subtotal: array[i].subtotal,
            order_no: array[i].order_no,
            diff_product_parent: array[i].diff_product_parent
          }
          detail.push(obj2)
        }
      }
      var data = {
        id: rtr.id,
        type: rtr.type,
        return_no: rtr.return_no,
        return_date: rtr.return_date,
        deliver_date: rtr.deliver_date,
        vendor_no: rtr.vendor_no,
        purchasing_no: rtr.purchasing_no,
        sale_no: rtr.sale_no,
        notes: rtr.notes,
        status: 'approve',
        branch_no: rtr.branch_no,
        company_no: rtr.company_no,
        lock: true,
        is_deliver: rtr.is_deliver,
        customer_no: rtr.customer_no,
        subtotal: rtr.subtotal,
        discount: rtr.discount,
        discount_percentage: rtr.discount_percentage,
        tax_id: rtr.tax_id,
        tax: rtr.tax,
        total: rtr.total,
        details: detail,
        salesman_id: rtr.salesman_id,
        category: rtr.category
      }
      return data
    }
  },
  methods: {
    async unlockRetur () {
      console.log(returnUrl + '/unlock')
      await Axios.post(returnUrl + '/unlock', { id: this.retur.id }, { headers: getHeader() })
        .then(response => {
          this.retur.lock = response.data.data.lock
          this.retur.status = response.data.data.status
          this.$swal('Success', response.data.message, 'success')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async validate () {
      this.alert = []
      var total = parseFloat(this.totalDetailReturn)
      if (total <= 0) {
        this.alert.push('<b>Total</b> masih <b>0</b>, Silahkan input data retur product')
      }
      if (this.retur.sale_no === null || this.retur.sale_no === '') {
        this.alert.push('<strong>Sale No.</strong>, tidak boleh kosong')
      }
    },
    async checkDate () {
      var date1 = new Date()
      date1.setHours(0, 0, 0, 0)
      var date2 = new Date(this.retur.return_date)
      date2.setHours(0, 0, 0, 0)
      var remaining = date2.getTime() - date1.getTime()
      var diffInDay = remaining / (1000 * 3600 * 24)
      console.log('Diff in a day ' + diffInDay)
      if (diffInDay > 0) {
        this.$swal('Error', 'Tanggal tidak boleh lebih dari hari ini (' + diffInDay + ' hari)', 'error')
        this.retur.return_date = date1.toISOString()
      } else if (Math.abs(diffInDay) > 2) {
        this.$swal('Error', 'Tanggal tidak boleh kurang dari 2 hari', 'error')
        this.retur.return_date = date1.toISOString()
      }
    },
    setIndexDetail (index) {
      this.detailIndex = index
      this.detailReturn = this.retur.details[index]
    },
    async removeRetur () {
      await this.$swal.fire({
        title: 'Are you sure Delete this?',
        text: "You won't be able to revert this!",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          Axios.delete(returnUrl + '/' + this.retur.id, { headers: getHeader() })
            .then(response => {
              console.log(response.data.message)
              this.setCOGSAll()
              this.backParent()
            })
            .catch(error => {
              console.log(error)
              console.log(error.response)
              this.$swal('Error', error.response.data.message, 'error')
              throw error
            })
        }
      })
    },
    async requestEdit (value) {
      var obj = {
        request_by: this.authUser.username,
        lock_no: this.retur.return_no,
        lock_note: value,
        type: 'return'
      }
      console.log(obj)
      await Axios.post(lockUrl, obj, { headers: getHeader() })
        .then(response => {
          this.$swal('Lock', 'Retur has been request edit', 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async requestVoid (value) {
      var obj = {
        request_by: this.authUser.username,
        lock_no: this.retur.return_no,
        lock_note: value,
        type: 'sales-return-void'
      }
      console.log(obj)
      await Axios.post(lockUrl, obj, { headers: getHeader() })
        .then(response => {
          this.$swal('Lock', 'Retur has been request edit', 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async setType () {
      if (this.retur.type === 'sales') {
        this.removePurchasing()
      } else {
        this.removeSale()
      }
    },
    async setProductRetur (index) {
      var detail = this.retur.details[index]
      var body = {
        product_no: detail.product_no
      }
      const prd = this.productListSelect.find(d => d.product_no === detail.product_no)
      console.log(prd)
      detail.uom_id = prd.uom_id
      await Axios.post(productUrl + '/uom/list', body, { headers: getHeader() })
        .then(response => {
          detail.uomList = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      var bodyData = {
        product_no: detail.product_no,
        date: this.retur.return_date,
        customer_no: this.retur.customer_no,
        vendor_no: this.retur.vendor_no
      }
      if (this.retur.type === 'sales') {
        console.log(productUrl + '/latest-price')
        await Axios.post(productUrl + '/latest-price', bodyData, { headers: getHeader() })
          .then(response => {
            console.log('latest price')
            console.log(bodyData)
            console.log(response.data.message)
            var data = response.data.data
            console.log(data)
            detail.amount = data.price
          })
          .catch(error => {
            console.log(error)
            console.log(error.response.data.message)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
        var dataCost = {
          date: this.retur.return_date,
          product_no: detail.product_no,
          company_no: this.retur.company_no
        }
        console.log(dataCost)
        await Axios.post(productUrl + '/cost/product', dataCost, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
            console.log(response.data.data)
            var data = response.data.data[0]
            this.retur.details[index].cost = data.cost_average
            this.retur.details[index].cost_id = data.id
            console.log('result')
            console.log(this.retur.details[index])
          })
      } else if (this.retur.type === 'purchasing') {
        var dataCosts = {
          date: this.retur.return_date,
          product_no: detail.product_no,
          company_no: this.retur.company_no
        }
        console.log(dataCosts)
        await Axios.post(productUrl + '/cost/product', dataCosts, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
            console.log(response.data.data)
            var data = response.data.data[0]
            detail.amount = data.cost_average
            detail.cost = data.cost_average
            detail.cost_id = data.id
          })
      }
      await this.calcrow(index)
    },
    async removePurchasing () {
      this.retur.purchasing_no = null
      this.retur.purchasing = {
        id: null,
        purchasing_no: null,
        purchasing_date: null,
        purchasing_due_date: null,
        ref_no: null,
        branch_no: null,
        vendor_no: null,
        subtotal: null,
        tax_id: null,
        tax: null,
        discount: null,
        total: null,
        delivery_cost: null,
        deliver_no: null,
        status: null,
        type_id: null,
        lock: null,
        company_no: null,
        term_due_id: null,
        ext_no: null,
        sp_no: null,
        discount_percentage: null,
        schedule_payment_date: null,
        notes: null,
        deliver_date: null,
        details: [{
          id: null,
          purchasing_no: null,
          purchasing_date: null,
          branch_no: null,
          product_no: null,
          product_sku: null,
          description: null,
          qty: null,
          qty_done: null,
          uom_id: null,
          price: null,
          tax_id: null,
          tax: null,
          discount: null,
          total: null,
          company_no: null,
          vendor_no: null,
          discount_percentage: null,
          subtotal: null,
          order_no: null
        }]
      }
      this.retur.vendor_no = null
      this.retur.vendor = {
        id: null,
        vendor_no: null,
        type_id: null,
        name: null,
        email: null,
        phone: null,
        mobile: null,
        vat: null,
        address: null,
        city_id: null,
        state_id: null,
        postalcode: null,
        alias: null,
        company_no: null
      }
      var rtrDetail = this.retur.details
      if (rtrDetail.length > 0) {
        await this.removeReturnAll()
      }
    },
    async removeSale () {
      this.retur.salesman_id = null
      this.retur.sale_no = null
      this.retur.sale = {
        id: null,
        sale_no: null,
        sale_date: null,
        sale_due_date: null,
        type_id: null,
        customer_no: null,
        customer: null,
        branch_no: null,
        subtotal: '0',
        tax_id: null,
        tax: '0',
        discount: '0',
        total: '0',
        delivery_cost: '0',
        deliver_no: '0',
        status: '0',
        price_id: null,
        warehouse_no: null,
        salesman_id: null,
        lock: null,
        company_no: null,
        term_due_id: null,
        print_counter: '0',
        bstk_counter: '0',
        return_total: '0',
        faktur_no: null,
        faktur_date: null,
        notes: null,
        commission_id: null,
        sale_commission_percentage: '0',
        sale_commission_amount: '0',
        details: [{
          id: null,
          sale_no: null,
          sale_date: null,
          branch_no: null,
          product_no: null,
          product_sku: null,
          description: null,
          qty: null,
          serial_number: null,
          uom_id: null,
          price: null,
          tax_id: null,
          tax: null,
          discount: null,
          total: null,
          queue: null,
          warehouse_no: null,
          internal_code: null,
          cost: null,
          cost_id: null,
          sec_serial_number: null,
          company_no: null,
          customer_no: null,
          discount_percentage: null,
          subtotal: null,
          order_no: null
        }]
      }
      this.retur.customer_no = null
      this.retur.customer = {
        id: null,
        name: null,
        customer_no: null,
        group_id: null,
        email: null,
        phone: null,
        address: null,
        city_id: null,
        state_id: null,
        identity_number: null,
        vat: null,
        birthday: null,
        birthplace: null,
        twitter: null,
        facebook: null,
        instagram: null,
        card_id: null,
        level_id: null,
        company_no: null,
        area_id: null,
        rating_id: null,
        term_due_id: null
      }
      var rtrDetail = this.retur.details
      if (rtrDetail.length > 0) {
        await this.removeReturnAll()
      }
    },
    async setJournalReturn (reply, data) {
      var body = {}
      if (data.length > 0) {
        body = {
          id: data.id
        }
      } else {
        body = {
          id: this.retur.id
        }
      }
      var resp = {
        error: false,
        message: null
      }
      if (this.retur.type === 'sales') {
        await Axios.post(returnUrl + '/journal-sales/', body, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
            resp.error = false
            resp.message = response.data.message
          })
          .catch(error => {
            console.log(error.response)
            resp.error = true
            resp.message = error.response.data.message
            throw error
          })
      } else if (this.retur.type === 'purchasing') {
        await Axios.post(returnUrl + '/journal-purchasing/', body, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
            resp.error = false
            resp.message = response.data.message
          })
          .catch(error => {
            console.log(error.response)
            resp.error = true
            resp.message = error.response.data.message
            throw error
          })
      }
      if (reply === 'reply') {
        if (resp.error === false) {
          await this.$swal('Success', resp.error.message, 'success')
          await this.$emit('backReload', this.retur.id)
        }
      }
    },
    getCustomerList: function () {
      this.$store.dispatch('getCustomerList')
    },
    getVendorList: function () {
      this.$store.dispatch('getvendorTypeList')
    },
    async setCOGSAll (reply) {
      var array = this.retur.details
      for (let i = 0; i < array.length; i++) {
        var data = {
          date: this.retur.return_date,
          product_no: array[i].product_no,
          type: 'all',
          company_no: null
        }
        console.log(data)
        var resp = {
          error: false,
          message: null
        }
        await Axios.post(productUrl + '/cost/sync', data, { headers: getHeader(), timeout: 1000 })
          .then(response => {
            console.log('success sync cogs')
            console.log(response.data.data)
            resp.error = false
            resp.message = response.data.message
            // this.$swal('Success', response.data.message, 'success')
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
        if (reply === 'reply') {
          if (resp.error === false) {
            this.$swal('Success', resp.message, 'success')
          }
        }
      }
    },
    async setCOGS () {
      var array = this.retur.details
      for (let i = 0; i < array.length; i++) {
        var date = new Date(array[i].return_date)
        var newDate = date.getFullYear() + '-' + (parseInt(date.getMonth()) + 1) + '-' + date.getDate()
        var data = {
          date: newDate,
          product_no: array[i].product_no,
          type: 'retur sales',
          company_no: this.retur.company_no
        }
        await Axios.post(productUrl + '/cost/sync', data, { headers: getHeader() })
          .then(response => {
            console.log('success sync cogs')
            console.log(response.data.data)
            this.$swal('Success', response.data.message, 'success')
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    addNewLine: function () {
      const warehouse = this.warehouseList.find(d => d.company_no === this.retur.company_no)
      this.retur.details.push({
        return_no: null,
        product_no: null,
        product: null,
        product_sku: null,
        serial_number: null,
        uom_id: null,
        qty: 1,
        amount: '0',
        notes: null,
        warehouse_no: warehouse ? warehouse.warehouse_no : null,
        warehouse: null,
        branch_no: null,
        company_no: this.retur.company_no,
        discount: '0',
        discount_percentage: '0',
        tax_id: this.retur.tax_id,
        tax: '0',
        subtotal: '0',
        total: '0',
        return_date: null,
        cost: '0',
        cost_id: null,
        penalty_amount: '0',
        order_no: null,
        diff_product_parent: true,
        uomList: [{
          id: null,
          name: null,
          category_id: null,
          category: null,
          type_id: null,
          ratio: null,
          active: null,
          cost: null
        }]
      })
      this.state = 'create'
    },
    async setProduct (index) {
      var no = index
      var proNo = this.sales.returns[0].details[no].product_no
      await Axios.get(productUrl + '/uom/' + proNo, { headers: getHeader() })
        .then(response => {
          var uoms = response.data.data
          var ud = uoms.find(u => u.category_id === 3)
          console.log(ud)
          if (ud) {
            this.sales.returns[0].details[no].uom_id = ud.uom_id
          }
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    setTax: function () {
      var array = this.retur.details
      for (let i = 0; i < array.length; i++) {
        this.calcrow(i)
      }
    },
    async updateRetur () {
      await this.validate()
      if (this.alert.length > 0) {
        await window.scrollTo(0, 0)
        await this.$swal('Validation', 'Data Retur Belum valid, cek inputan terlebih dahulu', 'error')
        return false
      }
      await this.calcAll()
      this.$Progress.start()
      this.loader.isLoading = true
      var resp = {
        error: false,
        message: null
      }
      await Axios.put(returnUrl + '/' + this.retur.id, this.dataCollect, { headers: getHeader() })
        .then(response => {
          resp.error = false
          resp.message = response.data.message
        })
        .catch(error => {
          console.log(error.response)
          resp.error = false
          resp.message = error.response.data.message
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.setCOGSAll('no reply')
      await this.setJournalReturn('no reply', [])
      await this.$Progress.finish()
      this.loader.isLoading = false
      this.alert = []
      await this.$swal('Success', resp.message, 'success')
      await this.backParent()
    },
    async createRetur () {
      await this.validate()
      if (this.alert.length > 0) {
        await window.scrollTo(0, 0)
        await this.$swal('Validation', 'Data Retur Belum valid, cek inputan terlebih dahulu', 'error')
        return false
      }
      await this.calcAll()
      await this.$Progress.start()
      this.loader.isLoading = true
      var resp = {
        error: false,
        message: null
      }
      var returnId = null
      await Axios.post(returnUrl, this.dataCollect, { headers: getHeader() })
        .then(response => {
          resp.error = false
          resp.message = response.data.message
          returnId = response.data.data.id
        })
        .catch(error => {
          console.log(error.response)
          resp.error = false
          resp.message = error.response.data.message
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.$Progress.finish()
      this.loader.isLoading = false
      this.$emit('backReload', returnId)
      await this.$swal('Retur', 'Process HPP and Journal?', 'success')
      await this.$Progress.start()
      this.loader.isLoading = true
      // await this.setCOGSAll('no reply')
      await this.setJournalReturn('no reply', [])
      // await this.$swal.fire({
      //   title: 'Journal',
      //   text: 'Process journal now?',
      //   icon: 'error',
      //   showCancelButton: true,
      //   confirmButtonColor: '#3085d6',
      //   cancelButtonColor: '#d33',
      //   confirmButtonText: 'Yes, process it!'
      // }).then((result) => {
      //   if (result.value) {
      //     this.$Progress.start()
      //     this.loader.isLoading = true
      //     this.setJournalReturn('no reply', [])
      //   }
      // })
      await this.$Progress.finish()
      this.loader.isLoading = false
      this.alert = []
      await this.$swal('Success', 'Success create retur', 'success')
      await this.$emit('backReload', returnId)
    },
    async createReturP () {
      var resp = {
        error: false,
        message: null
      }
      var refNo = null
      await Axios.post(returnUrl, this.dataCollect, { headers: getHeader() })
        .then(response => {
          resp.error = false
          resp.message = response.data.message
          refNo = response.data.data.return_no
        })
        .catch(error => {
          console.log(error.response)
          resp.error = false
          resp.message = error.response.data.message
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      this.dataCollect.type = 'purchasing'
      this.dataCollect.ref_no = refNo
      console.log(this.dataCollect)
      await Axios.post(returnUrl, this.dataCollect, { headers: getHeader() })
        .then(response => {
          resp.error = false
          resp.message = response.data.message
        })
        .catch(error => {
          console.log(error.response)
          resp.error = false
          resp.message = error.response.data.message
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.setCOGSAll('no reply')
      await this.$swal('Success', resp.message, 'success')
      await this.backParent()
    },
    async createScrap () {
      var resp = {
        error: false,
        message: null
      }
      this.dataCollect.type = 'scrap'
      await Axios.post(returnUrl, this.dataCollect, { headers: getHeader() })
        .then(response => {
          resp.error = false
          resp.message = response.data.message
        })
        .catch(error => {
          console.log(error.response)
          resp.error = false
          resp.message = error.response.data.message
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.setCOGSAll('no reply')
      await this.$swal('Success', resp.message, 'success')
      await this.backParent()
    },
    async setQtyTotal (code) {
      var d = new Date()
      var n = d.getFullYear()
      var n1 = n - 1
      this.year = [n1, n]
      var newYear = d.getFullYear()
      var newMonth = d.getMonth() + 1
      var newDate = d.getDate()
      var newSetDate = newYear + '-' + newMonth + '-' + newDate
      var comNo = this.sales.company_no

      await Axios.get(setQtyTotalUrl + '?end=' + newSetDate + '&available=true&company_no=' + comNo + '&product_no=' + code, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
        })
        .catch(error => {
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    async calcAll () {
      var array = this.retur.details
      for (let i = 0; i < array.length; i++) {
        console.log('detail row: ' + i)
        this.calcrow(i)
      }
    },
    async calcrow (index) {
      var detail = this.retur.details[index]
      var qty = detail.qty
      var amount = parseFloat(detail.amount.toString().replace(/\./g, ''))
      var discountPercentage = this.retur.details[index].discount_percentage === '' ? 0 : parseFloat(this.retur.details[index].discount_percentage)
      var discount = amount * discountPercentage / 100
      var subtotal = amount - discount
      var tax = this.taxList.find(d => d.id === this.retur.tax_id)
      var dpp = 0
      var taxAmount = 0
      if (tax.include === false) {
        taxAmount = subtotal * tax.amount / 100
        dpp = subtotal
      } else {
        if (tax.amount === '0') {
          taxAmount = 0
          dpp = subtotal
        } else {
          if (tax.amount === '11') {
            dpp = subtotal / 1.11
            taxAmount = Math.round(dpp) * 0.11
          } else {
            dpp = subtotal / 1.1
            taxAmount = Math.round(dpp) * 0.1
          }
        }
      }
      console.log(taxAmount)
      this.retur.details[index].discount = discount.toString()
      this.retur.details[index].subtotal = Math.round(dpp)
      this.retur.details[index].tax = taxAmount
      this.retur.details[index].tax_id = tax.id
      var totalDetailRow = (this.retur.details[index].subtotal + this.retur.details[index].tax) * qty
      this.retur.details[index].total = totalDetailRow
      if (this.retur.category === 'cancel') {
        this.retur.details[index].penalty_amount = totalDetailRow * 3 / 100
      } else {
        this.retur.details[index].penalty_amount = 0
      }
      this.retur.subtotal = this.totalSubtotalDetailReturn
      this.retur.discount = this.totalDiscountDetailReturn
      this.retur.tax = this.totalTaxDetailReturn
      // this.retur.total = this.totalDetailReturn
      console.log('Total DPP: ' + parseFloat(this.getTotalDPP + this.totalTaxDetailReturn))
      this.retur.total = parseFloat(this.getTotalDPP + this.totalTaxDetailReturn)
    },
    async removeReturnAll () {
      console.log('remove return all')
      var array = this.retur.details
      for (let i = 0; i < array.length; i++) {
        if (typeof array[i].id === 'undefined') {
          await this.retur.details.splice(i, 1)
        } else {
          await Axios.delete(returnUrl + '/detail/' + array[i].id, { headers: getHeader() })
            .then(response => {
              this.retur.details.splice(i, 1)
            })
            .catch(error => {
              console.log(error.response)
            })
        }
      }
    },
    removeReturn (index) {
      var rtr = this.retur.details[index]
      if (typeof rtr.id === 'undefined') {
        this.retur.details.splice(index, 1)
      } else {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            Axios.delete(returnUrl + '/detail/' + rtr.id, { headers: getHeader() })
              .then(response => {
                // set cogs
                var data = {
                  date: this.retur.return_date,
                  product_no: rtr.product_no,
                  type: 'all',
                  company_no: null
                }
                console.log(data)
                Axios.post(productUrl + '/cost/sync', data, { headers: getHeader() })
                  .then(response => {
                    console.log(response.data.message)
                  })
                  .catch(error => {
                    console.log(error)
                    console.log(error.response)
                  })
                this.retur.details.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
              })
          }
        })
      }
    },
    async addToReturn (index) {
      var sdetail = this.retur.sale.details[index]
      var tax = this.taxList.find(d => d.id === sdetail.tax_id)
      var returnDetail = this.retur.details.find(d => d.product_no === sdetail.product_no)
      if (typeof returnDetail === 'undefined') {
        var totalRetur = parseFloat(sdetail.qty) * (parseFloat(sdetail.price.replace(/\./g, '')) + parseFloat(sdetail.tax))
        var obj = {
          return_no: this.retur.return_no,
          product_no: sdetail.product_no,
          product: sdetail.description,
          product_sku: sdetail.product_sku,
          serial_number: null,
          uom_id: sdetail.uom_id,
          qty: sdetail.qty,
          amount: sdetail.price,
          cost: '0',
          cost_id: null,
          notes: null,
          warehouse_no: sdetail.warehouse_no,
          warehouse: sdetail.warehouse,
          branch_no: sdetail.branch_no,
          company_no: sdetail.company_no,
          discount: '0',
          discount_percentage: '0',
          tax_id: sdetail.tax_id,
          tax: sdetail.tax,
          taxes: tax.name,
          total: totalRetur,
          penalty_amount: '0',
          subtotal: '0',
          order_no: sdetail.order_no,
          diff_product_parent: false
        }
        this.retur.details.push(obj)
      }

      this.retur.subtotal = this.totalSubtotalDetailReturn
      this.retur.tax = this.totalTaxDetailReturn
      this.retur.total = this.totalDetailReturn
      await this.calcrow(index)
    },
    async addToReturnPurchasing (index) {
      var sdetail = this.retur.purchasing.details[index]
      console.log(sdetail)
      var tax = this.taxList.find(d => d.id === sdetail.tax_id)
      var returnDetail = this.retur.details.find(d => d.product_no === sdetail.product_no)
      const warehouse = this.warehouseList.find(d => d.company_no === this.retur.company_no)
      if (typeof returnDetail === 'undefined') {
        var totalRetur = parseFloat(sdetail.qty) * (parseFloat(sdetail.price.replace(/\./g, '')) + parseFloat(sdetail.tax))
        var obj = {
          return_no: this.retur.return_no,
          product_no: sdetail.product_no,
          product: sdetail.description,
          product_sku: sdetail.product_sku,
          serial_number: null,
          uom_id: sdetail.uom_id,
          qty: sdetail.qty,
          amount: sdetail.price,
          cost: '0',
          cost_id: null,
          notes: null,
          warehouse_no: warehouse ? warehouse.warehouse_no : null,
          branch_no: sdetail.branch_no,
          company_no: sdetail.company_no,
          discount: '0',
          discount_percentage: '0',
          tax_id: sdetail.tax_id,
          tax: sdetail.tax,
          taxes: tax.name,
          total: totalRetur,
          penalty_amount: '0',
          subtotal: '0',
          diff_product_parent: false
        }
        console.log(obj)
        this.retur.details.push(obj)
      }

      // this.retur.subtotal = this.totalSubtotalDetailReturn
      // this.retur.tax = this.totalTaxDetailReturn
      // this.retur.total = this.totalDetailReturn
      // await this.calcrow(index)
    },
    backParent () {
      this.alert = []
      this.$emit('backClicked')
    },
    printRetur () {
      console.log(sale2Url + '/print/' + this.retur.id + '/return?userId=' + this.authUser.id)
      window.open(sale2Url + '/print/' + this.retur.id + '/return?userId=' + this.authUser.id, '_blank')
    },
    createCustomer: function (customer) {
      this.sales.customer_no = customer.customer_no
      this.sales.customer = customer
    },
    createVendor: function (vendor) {
      this.sales.return[0].vendor_no = vendor.vendor_no
      this.sales.return[0].vendor = vendor
    },
    getSales: function () {
      this.$store.dispatch('getProductListSelect')
      this.$store.dispatch('getVendorList')
    },
    getPurchasing: function () {
      this.$store.dispatch('getProductListSelect')
      this.$store.dispatch('getVendorList')
    },
    async selectCustomerList (customer) {
      this.retur.customer_no = customer.customer_no
      this.retur.customer = customer
    },
    async selectVendorList (vendor) {
      this.retur.vendor_no = vendor.vendor_no
      this.retur.vendor = vendor
    },
    async selectSales (data) {
      var company = this.companyList.find(d => d.company_no === data.company_no)
      var taxid = company ? company.tax_id : null
      this.retur.tax_id = taxid
      this.retur.company_no = data.company_no
      this.retur.sale = data
      this.retur.sale_no = data.sale_no
      this.retur.customer_no = data.customer_no
      this.retur.customer = data.customer
      this.retur.salesman_id = data.salesman_id
      this.retur.details = []
    },
    async selectPurchasing (data) {
      var company = this.companyList.find(d => d.company_no === data.company_no)
      var taxid = company ? company.tax_id : null
      this.retur.tax_id = taxid
      this.retur.company_no = data.company_no
      this.retur.purchasing = data
      this.retur.purchasing_no = data.purchasing_no
      this.retur.vendor_no = data.vendor_no
      this.retur.vendor = data.vendor
      this.retur.details = []
    }
  }
}
</script>
